import React from "react"

import bigDigit from './images/bigDigit.png'
import globalStyles from "../../../../App.module.scss";

import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function ToBigDigits() {

    let data = `import sys

# Digit definition
digits = [[' ### ', '#   #', '#   #', '#   #', '#   #', '#   #', ' ### '],  # Zero
          ['  #  ', ' ##  ', '  #  ', '  #  ', '  #  ', '  #  ', ' ### '],  # One
          [' ### ', '    #', '    #', ' ### ', '#    ', '#    ', ' ### '],  # Two
          [' ### ', '    #', '    #', ' ### ', '    #', '    #', ' ### '],  # Three
          ['#   #', '#   #', '#   #', ' ### ', '    #', '    #', '    #'],  # Four
          [' ### ', '#    ', '#    ', ' ### ', '    #', '    #', ' ### '],  # Five
          [' ### ', '#    ', '#    ', ' ### ', '#   #', '#   #', ' ### '],  # Six
          [' ### ', '    #', '    #', '    #', '    #', '    #', '    #'],  # Seven
          [' ### ', '#   #', '#   #', ' ### ', '#   #', '#   #', ' ### '],  # Eight
          [' ### ', '#   #', '#   #', ' ### ', '    #', '    #', '    #']]  # Nine
try:

    # Function to convert the '#' to the numbers typed

    def translate(string, a, b):
        i = 0
        chars = list(string)
        while len(chars) > i:
            if chars[i] == a:
                chars[i] = b
            i += 1
        result = ''.join(chars)
        return result


    # Check for arguments, if no arguments detected the user is prompted for imput

    if len(sys.argv) > 1:
        number = str(sys.argv[1])
    else:
        number = str(input("Enter a number:"))

    # Printin the numbers on the screen
    i = 0
    print()
    while i < len(digits[i]):
        x = 0
        line = " "
        while x < len(number):
            line += translate(digits[int(number[x])][i], '#', str(number[x])) + " "
            x += 1
        print(line)
        i += 1


# Error handling

except ValueError as err:
    print(err)
except IndexError as err:
    print(err)
`
    return (
        <div className={globalStyles.article}>
            <h1>Big number converter</h1>
            <p>This program converts the numbers in its input to big numbers. It accepts 1 argument, if there is no
                argument, the user will be prompted to enter the numbers.</p>
            <div style={{ maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'bash'}
                />
            </div>
            <p>The program above produces the next output:</p>
            <div style={{maxWidth: '570px', maxHeight: '253px'}}>
                <img src={bigDigit} alt={""}/>
            </div>
        </div>
    )
}